// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Header_wrapper__EVJFY","title":"Header_title__rzyfp","compactWrapper":"Header_compactWrapper__mR_jC","titleWithIcon":"Header_titleWithIcon__baxdO"};